// src/utils/Pagination.jsx
import React from "react";
import { Pagination as SUPagination, Dropdown } from "semantic-ui-react";

const Pagination = ({
  totalItems,
  itemsPerPage,
  currentPage,
  onPageChange,
  onItemsPerPageChange,
  options = []
}) => {
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  if (totalPages <= 1) return null;

  return (
    <div style={{ display: "flex", justifyContent: "space-between", marginTop: 15 }}>
      <SUPagination
        activePage={currentPage}
        totalPages={totalPages}
        onPageChange={(e, data) => {
          if (data.activePage !== currentPage) {
            onPageChange(data.activePage);
          }
        }}
      />

      {options.length > 0 && (
        <Dropdown
          selection
          options={options}
          value={itemsPerPage}
          onChange={(e, data) => onItemsPerPageChange(data.value)}
        />
      )}
    </div>
  );
};

export default Pagination;
